export const manifest = {
  screens: {
    scr_rztrdb: { name: "Timer", route: "/", state: {"screen":"timer","entered":true}, position: {"x":1560,"y":220} },
    scr_9g0z82: { name: "Duration picker", route: "/", state: {"screen":"timer","durationOpen":true,"entered":true}, position: {"x":160,"y":220} },
    scr_xqnpb2: { name: "Focus sounds", route: "/", state: {"screen":"timer","soundOpen":true,"entered":true}, position: {"x":160,"y":2200} },
    scr_0x8ji7: { name: "Progress", route: "/", state: {"screen":"progress","entered":true}, position: {"x":2960,"y":220} },
    scr_mg212g: { name: "Settings", route: "/", state: {"screen":"settings","entered":true}, position: {"x":1560,"y":2200} },
    scr_u1fdjb: { name: "Landing", route: "/", state: {"entered":false}, position: {"x":0,"y":0}, isDefaultRow: true },
  },
  sections: {
    sec_q402i7: { name: "Timer flow", x: 0, y: 0, width: 4320, height: 1180 },
    sec_kvszml: { name: "Settings", x: 0, y: 1980, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_q402i7", children: [
      { kind: "screen", id: "scr_9g0z82" },
      { kind: "screen", id: "scr_rztrdb" },
      { kind: "screen", id: "scr_0x8ji7" },
    ] },
    { kind: "section", id: "sec_kvszml", children: [
      { kind: "screen", id: "scr_xqnpb2" },
      { kind: "screen", id: "scr_mg212g" },
    ] },
    { kind: "screen", id: "scr_u1fdjb" },
  ],
}
